import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui";
import { LogOut, Plus, LayoutDashboard } from "lucide-react";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  async function onLogout() {
    await logout();
    navigate("/login", { replace: true });
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-20 border-b border-border bg-background/80 backdrop-blur-xl">
        <div className="mx-auto max-w-6xl px-4 h-16 flex items-center justify-between">
          <Link to="/" className="text-lg font-bold tracking-tight">
            Averoan <span className="text-primary">Invoicing</span>
          </Link>
          <div className="flex items-center gap-2">
            <Link to="/">
              <Button variant={pathname === "/" ? "outline" : "ghost"} size="sm">
                <LayoutDashboard className="h-4 w-4" /> Dashboard
              </Button>
            </Link>
            <Link to="/invoices/new">
              <Button size="sm"><Plus className="h-4 w-4" /> New invoice</Button>
            </Link>
            <div className="mx-2 hidden sm:block text-sm text-muted-foreground">{user?.username}</div>
            <Button variant="ghost" size="sm" onClick={onLogout} title="Sign out">
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
